import React, { useContext } from 'react';

import { SkeletonLoader, DesktopScreen, MobileScreen, StaticContext } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

const AppDetailsSkeleton = props => {
  const { userAgent } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);
  return (
    <>
      <MobileScreen defaultMatches={!isDesktop}>
        <SkeletonLoader height={290} width={320} {...props}>
          <rect x="120" y="20" rx="0" ry="0" width="50" height="50" />

          <rect x="90" y="80" rx="0" ry="0" width="120" height="20" />
          <rect x="70" y="110" rx="0" ry="0" width="160" height="10" />

          <rect x="50" y="130" rx="0" ry="0" width="200" height="10" />
          <rect x="50" y="150" rx="0" ry="0" width="200" height="10" />
          <rect x="50" y="170" rx="0" ry="0" width="200" height="10" />
        </SkeletonLoader>
      </MobileScreen>
      <DesktopScreen defaultMatches={isDesktop}>
        <SkeletonLoader height={290} width={700} {...props}>
          <rect x="355" y="20" rx="0" ry="0" width="120" height="20" />
          <rect x="135" y="30" rx="0" ry="0" width="160" height="10" />
          <rect x="135" y="50" rx="0" ry="0" width="200" height="10" />

          <rect x="85" y="20" rx="0" ry="0" width="40" height="40" />

          <rect x="85" y="70" rx="0" ry="0" width="260" height="150" />
          <rect x="355" y="70" rx="0" ry="0" width="120" height="150" />

          <rect x="85" y="230" rx="0" ry="0" width="200" height="10" />
          <rect x="85" y="250" rx="0" ry="0" width="200" height="10" />
          <rect x="85" y="270" rx="0" ry="0" width="200" height="10" />
        </SkeletonLoader>
      </DesktopScreen>
    </>
  );
};

export default AppDetailsSkeleton;
